import React, {useState,useCallback,useEffect} from 'react';
import {
  Show,
  TabbedShowLayout,
  Tab,
  Datagrid,
  TextField,
  NumberField,
  List,
  ReferenceField,
  ReferenceManyField,
  DateField,
  BooleanField,
  TopToolbar,
  RefreshButton,
  ListButton,
  GET_ONE,
} from "react-admin";
import { CamelCaseField, ExpectedDateField } from "../digitalOrders/common";
import { getLocalStorageKey } from "../common/common";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
import Modal from "react-responsive-modal";
import Spinner from "../../src/spinner";
import myDataProvider from "../myRestProvider";
import { useLocation } from 'react-router-dom';

// const topToolbarStyle = {
//   zIndex: 2,
//   display: 'inline-block',
//   float: 'right',
// };
const ExampleApp = () => {
  const [open, setOpen] = useState(false);
  const [showloader, setShowLoader] = useState(true);
  const [reloadButton, setReloadButton] = useState(false);
  const [data, setData] = useState('');
  const [dateFlag, setDateFlag] = useState(false);

  const fetchItem = async (id) => {
    setShowLoader(true);
    setData(async () => {
      const json = await myDataProvider(GET_ONE, "getSapDetails", { id });
      const item = json.data;
      var countryTime = new Date(item.last_sap_update).toLocaleString("en-US");
      console.log("countryTime", countryTime);
      setShowLoader(false);
      setData(...item);
      setReloadButton(item.errorMsg === "Reload");
      setDateFlag(countryTime !== "Invalid Date");
    })
   
  };

  const onOpenModal = useCallback(() => {
    console.log(this.props);
    setOpen(true);
    setReloadButton(false);
    fetchItem(this.props.record.retailer_info.id);
  },[]);

  const onCloseModal = () => {
    setOpen(false);
  };
    return (
      <div className="detailsBtn">
        {!open ? (
          <p onClick={onOpenModal}>Check balance</p>
        ) : (
          <Modal open={open} onClose={onCloseModal} center>
            <table>
              <tr>
                <th>SAP credit area Cd</th>
                <th>Last SAP update</th>
                <th>Currency</th>
                <th>Credit limit</th>
                <th>Credit exposure SAP</th>
                <th>Credit exposure LOGON</th>
                <th>Open credit LOGON</th>
                <th>Orders not invoiced price</th>
                <th>Digital order balance</th>
              </tr>
              <tr>
                <td>{data.sap_credit_area_cd}</td>
                <td>
                  {dateFlag && data.last_sap_update}
                </td>
                <td>{data.currency}</td>
                <td>{data.credit_limit}</td>
                <td>{data.credit_exposure_sap}</td>
                <td>{data.credit_exposure_logon}</td>
                <td>{data.open_credit_logon}</td>
                <td>{data.orders_not_invoiced_price}</td>
                <td>{data.sap_digital_order_balance}</td>
              </tr>
              <tr className="errorMsg">
                <td colSpan="9">
                  {reloadButton && window.navigator.onLine && (
                    <div>{data.msgText}</div>
                  )}
                </td>
              </tr>
              <tr>
                <td className="spinner" colSpan="9">
                  <div className="spinner">
                    {showloader && window.navigator.onLine && (
                      <Spinner />
                    )}
                  </div>
                  {reloadButton && window.navigator.onLine && (
                    <div className="refresh">
                      <i onClick={this.reload} className="material-icons">
                        refresh
                      </i>
                    </div>
                  )}
                  <div>
                    {!window.navigator.onLine && (
                      <p>
                        It seems that you are offline. Please check your
                        internet connection
                      </p>
                    )}
                  </div>
                </td>
              </tr>
            </table>
          </Modal>
        )}
      </div>
    );
  
}

const PayerBalance = (props) => {
  const [open, setOpen] = useState(false);
  const [showloader, setShowLoader] = useState(true);
  const [payerReloadButton, setPayerReloadButton] = useState(true);
  const [data, setData] = useState('');
  const [last_sap_update, setLastSapUpdate] = useState(null);
  const [dateFlag, setDataFlag] = useState(false);

  useEffect(() => {
    fetchItem(props.id);
  });

 const reload = () => {
  setPayerReloadButton(false);
  setShowLoader(true);
  fetchItem(props.id);
  };

 const fetchItem = (id) => {
    console.log("fetch console");
    const { state } = this;
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "POST";
    options.body = JSON.stringify({
      id: id,
      business_id: this.props.record.business && this.props.record.business.id,
    });

    let item;
    if (!this.props.record.business) {
      // this.setState({ payerReloadButton: true, showloader: false });
      setPayerReloadButton(true);
      setShowLoader(false);
    }
    if (this.props.record.business) {
      // this.setState({ showloader: true });
      setShowLoader(true);

      fetch(`${apiUrl}/get_payer_balance`, options)
        .then((res) => {
          return res.json();
        })
        .then((json) => {
          console.log("json>>>>", json);
          item = json.data;
          const countryTime = new Date(item.last_sap_update).toLocaleString(
            "en-US"
          );
          if (item) {
            // this.setState({ showloader: false });
            setShowLoader(false);
          }
          // this.setState({ data: item });
          // this.setState({ last_sap_update: countryTime });
          setData(item);
          setLastSapUpdate(countryTime);
        });
      console.log("items are", item);
    }
    // if (item.errorMsg === 'Reload') {
    //   this.state.reloadButton = true;
    // }

    // if (this.state.last_sap_update !== 'Invalid Date') {
    //   // this.state.last_sap_update = "sd"
    //   this.setState({ dateFlag: true })
    // }
  };
 
    console.log(" this.state.payerReloadButton", payerReloadButton);
    return (
      <div className="soldToDetails">
        <table>
          <tbody>
            <tr></tr>
            <tr>
              <th>SAP credit area Cd</th>
              <th>Last SAP update</th>
              <th>Currency</th>
              <th>Credit limit</th>
              <th>Credit exposure SAP</th>
              <th>Credit exposure LOGON</th>
              <th>Open credit LOGON</th>
              <th>Orders not invoiced price</th>
              <th>Digital order balance</th>
            </tr>
            <tr>
              <td>{data.payer_sap_code}</td>
              <td>{last_sap_update}</td>
              <td>{data.currency}</td>
              <td>{data.credit_limit}</td>
              <td>{data.credit_exposure_sap}</td>
              <td>{data.credit_exposure_logon}</td>
              <td>{data.open_credit_logon}</td>
              <td>{data.orders_not_invoiced_price}</td>
              <td>{data.sap_digital_order_balance}</td>
            </tr>
            <tr>
              <td className="errorMsg" colSpan="9">
                {payerReloadButton && window.navigator.onLine && (
                  <div>{data.errorMsg}</div>
                )}
              </td>
            </tr>
            <tr>
              <td className="spinner" colSpan="9">
                <div className="spinner">
                  {showloader && window.navigator.onLine && (
                    <Spinner />
                  )}
                </div>
                {payerReloadButton && window.navigator.onLine && (
                  <div className="refresh">
                    <i onClick={reload} className="material-icons">
                      refresh
                    </i>
                  </div>
                )}
                <div>
                  {!window.navigator.onLine && (
                    <p>
                      It seems that you are offline. Please check your internet
                      connection
                    </p>
                  )}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  
}

const ShowActions = ({ basePath }) => (
  <TopToolbar>
    <RefreshButton />
    <ListButton basePath={basePath} />
  </TopToolbar>
);

const ShowTitle = ({ record }) => {
  return (
    record && (
      <span>
        Contract {record.contract_number ? `#${record.contract_number}` : ""}
      </span>
    )
  );
};

const ContractsShow = ({ permissions, ...props }) => {
  const showAllOrders = getLocalStorageKey('show_all_orders');
  const location = useLocation();
  const pathSplit = location.pathname.split("/");
  const businessIdVal = pathSplit[2];
  return (
    <Show
      actions={<ShowActions permissions={permissions} />}
      {...props}
      title={<ShowTitle />}
    >
      <TabbedShowLayout className="tab-scroll">
        <Tab label="Contract Details" contentClassName="scrollTab">
          <TextField source="contract_number" />
          <TextField source="contract_type" />
          <ReferenceField
            label="Sold To Name"
            source="retailer_info.id"
            reference="businesses"
            link="show"
            allowEmpty
          >
            <TextField source="name" />
          </ReferenceField>

          <TextField source="retailer_info.sap_code" 
          // label="Sold To ID" 
          />
          <DateField 
          // label="Contract Valid From" 
          source="contract_valid_from" />

          <DateField 
          // label="Contract Valid To" 
          source="contract_valid_to" />
          {permissions === "isSap" && <ExampleApp id={props.id} />}
          <TextField source="inco_term" />
          <BooleanField source="status" />
          <DateField 
          // label="Created at" 
          source="created_at" />
        </Tab>
        <Tab label="Payers">
          <ReferenceManyField
            label=""
            addLabel={false}
            sort={{ field: "created_at", order: "DESC" }}
            reference="sap_contract_payers"
            source="id"
            target="sap_contract_id"
            className="tab-pagination"
          >
            <List actions={false} {...props} filterDefaultValues={{ sap_contract_id: businessIdVal }} exporter={false}>
              <Datagrid expand={<PayerBalance payerDetails={props} />} bulkActionButtons={false}>
                <TextField source="payer_name" />
                <TextField source="payer_sap_code" />
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>
        {/* <Tab label="Payers">
                    <ReferenceManyField
                        addLabel={false}
                        sort={{ field: 'created_at', order: 'DESC' }}
                        reference="sap_contract_payers"
                        source="id"
                        target="sap_contract_id"
                    >
                    <Datagrid rowClick="show">
                                <TextField source="payer_name"/>
                                <TextField source="payer_sap_code"/>
                            </Datagrid>
                    </ReferenceManyField>
                </Tab> */}
        <Tab label="Ship-Tos">
          <ReferenceManyField
            label=""
            addLabel={false}
            sort={{ field: "created_at", order: "DESC" }}
            reference="sap_business_sites"
            source="id"
            target="sap_contract_id"
            className="tab-pagination"
          >
            <List actions={false} {...props} filterDefaultValues={{ sap_contract_id: businessIdVal }} exporter={false}>
              <Datagrid rowClick="show" bulkActionButtons={false}>
                <TextField label="Ship To ID" source="ship_to_sap_number" />
                <TextField label="Ship To Name" source="name" allowEmpty />
                <TextField source="phone" sortable={false} allowEmpty />
                <ReferenceField
                  label="Sold To Name"
                  source="business_id"
                  reference="businesses"
                  link="show"
                  allowEmpty
                >
                  <TextField source="name" />
                </ReferenceField>
                <TextField
                  // label="Sold To ID"
                  source="retailer_sapcode"
                  sortable={false}
                />
                <DateField 
                // label="Created at" 
                source="created_at" allowEmpty />
                <TextField source="status" />
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>
        <Tab label="Orders">
          <ReferenceManyField
            label=""
            addLabel={false}
            sort={{ field: "created_at", order: "DESC" }}
            reference={
              showAllOrders ? "sap_digital_orders" : "sap_digital_app_orders"
            }
            source="id"
            target="sap_contract_id"
            className="tab-pagination"
          >
            <List actions={false} {...props} filterDefaultValues={{ sap_contract_id: businessIdVal }} exporter={false}>
              <Datagrid rowClick="show" bulkActionButtons={false}>
                <DateField label={"Order Date"} source="creation_date" />
                <ReferenceField
                  label="Sold To Name"
                  source="business_id"
                  reference="businesses"
                  link="show"
                  allowEmpty
                >
                  <TextField source="name" />
                </ReferenceField>
                <TextField source="order_number" />
                <CamelCaseField
                  source="mode_of_delivery"
                  label="Mode Of Delivery"
                />
                <ExpectedDateField
                  // label="Expected Date"
                  source="delivery_date_from"
                />
                <TextField 
                // label="Local PO Note" 
                source="customer_ref_number" />
                <TextField
                  label="Order Status"
                  source="customer_order_status_desc"
                />
                <ReferenceField
                  label="Ship To Name"
                  source="sap_business_site_id"
                  reference="sap_business_sites"
                  link="show"
                  allowEmpty
                >
                  <TextField source="name" />
                </ReferenceField>
                {permissions === "isSap" && (
                  <DateField label="Date 1st seen in LR" source="created_at" />
                )}
                {permissions === "isSap" && showAllOrders && (
                  <TextField label="Is App Order" source="is_app_order" />
                )}
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>
        <Tab label="Products">
          <ReferenceManyField
            label=""
            addLabel={false}
            sort={{ field: "created_at", order: "DESC" }}
            reference="sap_contract_products"
            source="id"
            target="sap_contract_id"
            className="tab-pagination"
          >
            <List actions={false} {...props} filterDefaultValues={{ sap_contract_id: businessIdVal }} exporter={false}>
              <Datagrid bulkActionButtons={false}>
                <TextField source="material_number" />
                <TextField source="material_description" />
                <TextField source="position" />
                {/* <TextField source="plant_code" /> */}
                <TextField label="Plant" source="sap_plant.name" />
                {/* <TextField source="shipping_point" /> */}
                <TextField
                  label="Shipping Point"
                  source="shipping_point_plant.name"
                />
                <NumberField source="net_price" />
                <NumberField label="VAT(%)" source="vat" />
                <NumberField source="price_after_tax" />
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default ContractsShow;